{
    "action__edit": "Modifier",
    "action__copy_address": "Copier l'adresse"
}
